module.exports = __webpack_public_path__ + "static/media/WtbProdsProds.68425cca.png";